export default "__VITE_ASSET__fLS4YQYr__"